// The design lock for every word the player reads outside the manual (the
// manual's verses are in src/config/verses.ts). No words ever sit on the
// table itself: only on the title, the Codex and the veil.

export const WORDS = {
  title: "Ternion",
  tagline: "recovered from a place that counts in threes",
  // the two ways between the game and the introit (/introit), both glyphs
  // with no words: these are only read aloud
  links: { watch: "Watch the rites play themselves", play: "Enter" },
  // begin anew is a glyph under the tablets; these are only read aloud
  anew: { ask: "Begin anew", confirm: "Press again to forget every rite won" },
  // the last rite is a glyph under the tablets once all three are whole; read aloud only
  ternion: "The Ternion: the three tablets, to fold as one",
  veil: {
    moves: "moves",
    par: "par",
    unaided: "unaided",
    back: "Return to the lattice",
  },
  codex: {
    title: "Codex",
    close: "Close",
    tabs: { laws: "Laws", seals: "Seals", glyphs: "Glyphs", order: "Order", fragments: "Fragments" },
    sealsNote: "Each seal opens when you first make its law happen on the table. It keeps the moment you did.",
    glyphsNote: "Choose a glyph to write about it.",
    glyphNotes: "What do you think this glyph means?",
    single: "Single",
    folded: "Folded",
    noneYet: "None yet.",
    orderNote: "Every glyph has one true place. Drag a glyph you have seen to where you think it belongs.",
    orderEmpty: "Glyphs you meet on the table gather here.",
    orderWhole: "Every glyph is in its place. The order is whole.",
    fragmentsNote: "Words the makers left, found as you go.",
  },
  aria: {
    title: "Title",
    lattice: "The lattice of rites",
    play: "The table",
    begin: "Begin",
    undo: "Take back the last move",
    restart: "Begin the rite again",
    rosetta: "Rosetta: read every card in plain marks",
    book: "Codex: the laws and your notes",
    sound: "Sound",
    glimmer: "Glimmer: light the cards that can move. Press again to see the next move on the way",
    moves: "Moves",
    glyph: "Glyph",
    placed: "Placed glyph",
    emptyPlace: "Empty place",
    notFound: "Not yet found",
    notWitnessed: "Not yet witnessed",
  },
} as const
